import { render } from "./dataLog.vue?vue&type=template&id=5fa8413e&scoped=true"
import script from "./dataLog.vue?vue&type=script&lang=js"
export * from "./dataLog.vue?vue&type=script&lang=js"

import "./dataLog.vue?vue&type=style&index=0&id=5fa8413e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa8413e"]])

export default __exports__